<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Добавить единицу измерения</h4>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form autcomplete="off" @submit.prevent="unitStore()">
                  <div class="form-group">
                    <label>Единица измерения</label>
                    <input type="text" placeholder="чел" class="form-control" v-model="unit.ru_title" autofocus />
                  </div>
                  <div class="form-group">
                    <label>Код</label>
                    <input type="text" placeholder="chel" class="form-control" v-model="unit.code" />
                  </div>
                  <div class="form-group">
                    <label>Код ОКЕИ</label>
                    <input type="text" placeholder="792" class="form-control" v-model="unit.okei_id" />
                  </div>
                  <div class="form-group">
                    <label>Загаловок единст число</label>
                    <input type="text" placeholder="человек" class="form-control" v-model="unit.ru_titleSingular" />
                  </div>
                  <div class="form-group">
                    <label>Загаловок множ число</label>
                    <input type="text" placeholder="люди" class="form-control" v-model="unit.ru_titlePlural" />
                  </div>
                  <button type="submit" class="btn btn-primary">Добавить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, POST } from "../../shared/api";
export default {
  data() {
    return {
      unit: {},
      units: []
    };
  },
  methods: {
    getUnits() {
      GET([], "/unit", this, false).then(response => {
        this.units = response;
      });
    },
    unitStore() {
      POST(this.unit, "/unit", this).then(response => {
        this.$router.push({ name: "unit" });
      });
    }
  },
  created() {
    this.getUnits();
  },
  mounted() {
    let input = document.querySelector("[autofocus]");
    if (input) {
      input.focus();
    }
  }
};
</script>
